import { Component, Input, ViewChild, AfterViewInit, OnChanges, SimpleChanges,Output, EventEmitter  } from '@angular/core';
import { HttpClient, HttpParams, provideHttpClient } from '@angular/common/http';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
import { merge, of as observableOf } from 'rxjs';
import { Apiv1Service } from '../../../../services/apiv1.service';
import { NgFor,NgIf } from '@angular/common';
import { FormaddComponent, FormAddConfig, FormAddField } from "../../../containers/form/formadd/formadd.component";
import { FormupdateComponent, FormUpdateConfig, FormUpdateField } from "../../../containers/form/formupdate/formupdate.component";
import { TablepagedComponent, ColumnDef, ColumnOptions} from "../../../containers/table/tablepaged/tablepaged.component";



@Component({
  selector: 'app-update-add-table',
  imports: [FormaddComponent, FormupdateComponent, TablepagedComponent],
  templateUrl: './update-add-table.component.html',
  styleUrl: './update-add-table.component.scss',
})
export class UpdateAddTableComponent {

constructor(private store: Apiv1Service) {
}





init(): void {

this.columns = {};

    this.formConfigAdd = {
      title: "Add an "+this.element_name,
      buttonLabel: "add "+this.element_name,
      postPath: this.path,
      fields: []    
    };


    this.config.forEach(f => {
      this.columns[f.store_key] = f;

      this.columns[f.store_key]["options"] = f.column_options;

      if (f.store_key !== this.id_field)
      {
        if ( f.hidden === undefined || !f.hidden )
        {
            var field :       FormAddField    = { label: f.title, placeholder: "please enter "+f.title, store_key: f.store_key };
            
            if (f.hint !== undefined) {
              field["hint"] = f.hint;
            }
            if (f.type !== undefined) {
              field["type"] = f.type;
            }

            if (f.options_path !== undefined) {
              ;
              field.options=[];

              this.store.getAllForPath(f.options_path, new HttpParams()).subscribe(
                success => {
                  if (success) {
                    success.forEach(f => {

                      field.options?.push( { value: f.Id, label: f.Name } )

                      //console.log("Var [f.store_key] "+ JSON.stringify(f.store_key));


                    }
                  );
                  } else {
                    
                  }
                },
                () => {
                }
              );
            }

            this.formConfigAdd.fields.push(
            field
          );
        }
      }
      
    });

    this.form_add_generated=true;
}
ngOnChanges(changes: SimpleChanges) {
    if (changes['config']) {
      this.init();
    }
  }
@Input() form_add=true;
form_add_generated=false;
form_update=false;

 formConfigAdd!: FormAddConfig;
 formConfigUpdate!: FormUpdateConfig;

columns!: Record<string, ColumnDef>;
@Input() config!: Array<AttributeDefinition>;


@Input() title="title";
@Input() description="desc";

@Input() id_field="Id";
@Input() element_name="element";

@Input() path: string = "";
@Input() showUpdateButton = true;
@Input() showDeleteButton = true;


onUpdate(row: any) {
  console.log("want to update "+ JSON.stringify(row));

var f = [];



this.formConfigUpdate = {
  title: "Update "+ this.element_name +" with id ["+row[this.id_field]+"]",
  buttonLabel: "Update "+this.element_name,
  putPath: this.path + "/" + row[this.id_field],
  fields:[]
};
    this.config.forEach(f => {

      if (f.store_key !== this.id_field)
      {
        if ( f.hidden === undefined || !f.hidden )
        {

          
            var field :       FormUpdateField    = { label: f.title, placeholder: "please enter "+f.title, store_key: f.store_key, value: row[f.store_key] };
            //var fieldUpdate : FormUpdateField = { label: f.title, placeholder: "please enter "+f.title, store_key: f.store_key };
            
            if (f.hint !== undefined) {
              field["hint"] = f.hint;
              //fieldUpdate["hint"] = f.hint;
            }
            this.formConfigUpdate.fields.push(
            field 
          );
        }
      }
      
    });
    this.form_update = true;
}


@ViewChild(TablepagedComponent) table!: TablepagedComponent;

reloadTable() {
  this.table.reload();  // call the child table method
  this.form_update=false;
}

}

export enum InputType {
  text     = "text",
  textarea = "textarea",
  select   = "select"
}

export  interface AttributeDefinition {
  title: string;
  hint?: string;
  hidden?: boolean;
  store_key: string;
  type?: InputType;
  options_path?: string;
  column_options?: ColumnOptions;
}
